var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPinLight = function SvgIconPinLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_pin_light_svg__a)",
    fill: "#121619"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 21.8C11 14.05 17.037 9 23.6 9s12.6 5.05 12.6 12.8c0 2.903-1.147 5.672-3.076 8.409-1.924 2.73-4.676 5.498-7.998 8.417a2.375 2.375 0 0 1-1.526.574 2.375 2.375 0 0 1-1.526-.574C18.75 35.706 16 32.94 14.076 30.21 12.147 27.472 11 24.703 11 21.8Zm12.6-10.6c-5.437 0-10.4 4.15-10.4 10.6 0 2.297.903 4.628 2.674 7.141s4.362 5.14 7.628 8.011a.304.304 0 0 0 .072.042.075.075 0 0 0 .026.006c.002 0 .01 0 .026-.006a.304.304 0 0 0 .072-.042c3.266-2.872 5.857-5.498 7.628-8.01C33.097 26.427 34 24.096 34 21.8c0-6.45-4.963-10.6-10.4-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6 24.1a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_pin_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(11 9)",
    d: "M0 0h25.2v30.2H0z"
  })))));
};
export default SvgIconPinLight;